// Module
var code = "<div class=\"base-map-container\">\n  <am-map-component\n    map-options=\"$ctrl.mapOptions\"\n    map-name=\"$ctrl.mapName\"\n    popup-template=\"$ctrl.popupTemplate\"\n    custom-projection=\"$ctrl.customProjection\"\n    data=\"$ctrl.data\"\n    selected-regions=\"$ctrl.selectedRegions\">\n  </am-map-component>\n</div>\n";
// Exports
module.exports = code;